import React, { useEffect, useState } from 'react';
import { isEmpty, map } from 'lodash';
import translateService from '../../../common/translateService';
import common from '../../../common/common';
import { getQAndA } from '../../../services/questionAndAnswers/questionAndAnswersService';
import { setStartAndEndIndexes } from '../../../services/pagination/paginationService';
import Button from '../../Button.jsx';
import ProductQuestionAndAnswer from './ProductQuestionAndAnswer.jsx';
import './ProductQuestionsAndAnswers.scss';

const AllQuestions = (props) => {
    const [questions, setQuestions] = useState({
        productSlug: '',
        questions: [],
        sortType: 2,
        viewingCount: 0,
        productTitle: null,
        writeAQuestionLink: '',
        guidelinesLink: '',
        allQuestionsLink: '',
        goToProductLink: '',
        isUserAuthenticated: false,
        page: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 1,
    });

    async function init() {
        const q = await getQAndA(props.slug, 10);
        setQuestions(q);
    }

    useEffect(() => {
        init();
    }, []);

    const changeSortType = async (sortType) => {
        if (sortType === questions.sortType) return;

        const q = await getQAndA(props.slug, 10, 0, sortType);
        setQuestions(q);
    };

    const handlePageChange = async (pageNumber) => {
        const q = await getQAndA(
            props.slug,
            10,
            pageNumber,
            questions.sortType
        );
        setQuestions(q);

        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    };

    const buildPagination = () => {
        const currentPage = questions.page < 1 ? 1 : questions.page;
        const scrollPages = 5;

        if (questions.totalRecords === 0) return <></>;

        const [startIndex, endIndex] = setStartAndEndIndexes(
            questions.totalPages,
            scrollPages,
            currentPage
        );

        const pages = [];
        for (let i = startIndex; i <= endIndex; i++) {
            pages.push(
                <li
                    key={i}
                    className={`pagination__page ${
                        currentPage === i ? 'pagination__page--active' : ''
                    }`.trim()}>
                    <a
                        onClick={() => {
                            handlePageChange(i);
                        }}>
                        {i}
                    </a>
                </li>
            );
        }

        return (
            <ul className='pagination__pages'>
                {currentPage === 1 ? (
                    <li className='pagination__page pagination__page--inactive'>
                        &#10094;
                    </li>
                ) : (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(currentPage - 1);
                            }}>
                            &#10094;
                        </a>
                    </li>
                )}
                {startIndex > 1 && (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(1);
                            }}>
                            1
                        </a>
                    </li>
                )}
                {startIndex > 2 && (
                    <li className='pagination__page pagination__page--inactive'>
                        ...
                    </li>
                )}
                {pages}
                {endIndex < questions.totalPages - 1 && (
                    <li className='pagination__page pagination__page--inactive'>
                        ...
                    </li>
                )}
                {endIndex < questions.totalPages && (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(questions.totalPages);
                            }}>
                            {questions.totalPages}
                        </a>
                    </li>
                )}
                {currentPage === questions.totalPages ? (
                    <li className='pagination__page pagination__page--inactive'>
                        &#10095;
                    </li>
                ) : (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(currentPage + 1);
                            }}>
                            &#10095;
                        </a>
                    </li>
                )}
            </ul>
        );
    };

    return (
        <>
            <div className='prd-questions-heading'>
                <h1>
                    <a href={questions.goToProductLink}>
                        {translateService.interpolate(
                            `questions.questionsTitle`,
                            {
                                title: questions.productTitle,
                            }
                        )}
                    </a>
                </h1>
            </div>
            <div className='prd-questions-text mb-1'>
                {!questions.isUserAuthenticated && (
                    <>
                        <p>
                            {translateService.get(`questions.mustBeLoggedIn`)}
                        </p>
                        <p
                            className='prd-link'
                            onClick={() => {
                                window.location = common.getSiteUrl(
                                    `${
                                        window.$pathBase
                                    }Account/LogOn?returnUrl=${encodeURIComponent(
                                        questions.allQuestionsLink +
                                            window.location.search
                                    )}`
                                );
                            }}>
                            {translateService.get(`questions.clickToLogIn`)}
                        </p>
                    </>
                )}
                {isEmpty(questions.questions) && (
                    <p>{translateService.get(`questions.noQuestions`)}</p>
                )}
            </div>
            <div className='prd-questions-text-info'>
                <p>{translateService.get(`questions.questionInfo`)}</p>
                <p
                    className='small'
                    dangerouslySetInnerHTML={{
                        __html: translateService.interpolate(
                            `questions.readTheGuideLines`,
                            {
                                guidelinesLink: common.getSiteUrl(
                                    questions.guidelinesLink
                                ),
                            }
                        ),
                    }}
                />
            </div>
            <div className='prd-questions-button-container'>
                <Button
                    className='prd-questions-button'
                    text={translateService.get(`questions.makeAQuestion`)}
                    onClick={() => {
                        window.location = common.getSiteUrl(
                            questions.writeAQuestionLink
                        );
                    }}
                />
            </div>
            <div className='prd-questions-sort'>
                <div>
                    <strong>{translateService.get(`questions.sortBy`)}</strong>
                </div>
                <div
                    onClick={() => {
                        changeSortType(1);
                    }}
                    className={`prd-questions-sort-item ${
                        questions.sortType === 1 ? 'active' : ''
                    }`.trim()}
                    title={translateService.get(
                        `questions.sortByMostAnswersTitle`
                    )}>
                    {translateService.get(`questions.sortByMostAnswers`)}
                </div>
                <div
                    onClick={() => {
                        changeSortType(2);
                    }}
                    className={`prd-questions-sort-item ${
                        questions.sortType === 2 ? 'active' : ''
                    }`.trim()}
                    title={translateService.get(
                        `questions.sortByMostRecentTitle`
                    )}>
                    {translateService.get(`questions.sortByMostRecent`)}
                </div>
            </div>
            <div className='prd-questions'>
                {map(questions.questions, (q, idx) => (
                    <ProductQuestionAndAnswer
                        question={q}
                        key={idx}
                        isAuthenticated={questions.isUserAuthenticated}
                        isMobile={window.innerWidth < 1024}
                    />
                ))}
            </div>
            <div className='prd-questions-footer'>
                <a
                    className='prd-questions-footer-link prd-link'
                    href={common.getSiteUrl(questions.goToProductLink)}>
                    {translateService.get(`questions.goToProduct`)}
                </a>
                {!isEmpty(questions.questions) && buildPagination()}
            </div>
        </>
    );
};

export default AllQuestions;
